//#region DevExtreme Imports

import 'devextreme/ui/load_indicator'
import 'devextreme/ui/scroll_view'

//#endregion
import { LocationService, LOCATION_SERVICE_NAME, LocationEquipmentService, LOCATION_EQUIPMENT_SERVICE_NAME } from '../../../services/location'
import { LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { LocationsDetailsDirectiveController } from './locations-details.directive.controller'

import { DataTypeGroupService, DATA_TYPE_GROUP_SERVICE_NAME } from '../../../services/data-type'
import { DeviceService, DEVICE_SERVICE_NAME } from '../../../services/device'
import { GridService, GRID_SERVICE_NAME } from '../../../services/grid'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { EXTENDED_PARAMETERS_SERVICE_NAME, ExtendedParametersService } from '../../../services/extended-parameters'
import { MeterService, METER_SERVICE_NAME } from '../../../services/meter'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { SYSTEM_SERVICE_NAME, SystemService } from '../../../services/system'
import { ReferenceTypeService, REFERENCE_TYPE_SERVICE_NAME } from '../../../services/reference-type'

//#region Asset Imports

import './locations-details.scss'
import * as TEMPLATE from './locations-details.tpl.html'

//#endregion

// #region Setup

export class LocationsDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        $Q_SERVICE_NAME,
        'logger',
        'localDictionary',
        '$sce',
        USER_SESSION_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        LOCATION_SERVICE_NAME,
        LOCATION_EQUIPMENT_SERVICE_NAME,
        DEVICE_SERVICE_NAME,
        METER_SERVICE_NAME,
        GRID_SERVICE_NAME,
        DATA_TYPE_GROUP_SERVICE_NAME,
        EXTENDED_PARAMETERS_SERVICE_NAME,
        REFERENCE_TYPE_SERVICE_NAME,
        (
            $scope: any,
            $timeout: ng.ITimeoutService,
            $q: ng.IQService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            $sce: ng.ISCEService,
            userSession: UserSessionService,
            systemService: SystemService,
            locationService: LocationService,
            locationEquipmentService: LocationEquipmentService,
            deviceService: DeviceService,
            meterService: MeterService,
            gridService: GridService,
            dataTypeGroupService: DataTypeGroupService,
            extendedParametersService: ExtendedParametersService,
            referenceTypeService: ReferenceTypeService
        ) => {
            return new LocationsDetailsDirectiveController(
                $scope,
                $timeout,
                $q,
                logger,
                localDictionary,
                $sce,
                LocationService.REFERENCE_TYPE,
                LocationService.SIMAX_MODULE_NAME,
                userSession,
                systemService,
                locationService,
                locationEquipmentService,
                deviceService,
                meterService,
                gridService,
                dataTypeGroupService,
                extendedParametersService,
                referenceTypeService
            )
        }
    ]

    template = TEMPLATE
}

// #endregion
